import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/shop',
            name: 'shopLayout',
            component: () => import("./views/shopLayout.vue"),
            children: [
                {
                    path: '/network/shop',
                    name: 'shop',
                    component: () => import("./views/shop.vue"),
                    meta: {
                        hasBar: true,
                        bottomCutFixed: true
                    }
                },
                {
                    path: '/network/shop/:categoryIdentifier',
                    name: 'categoryOffers',
                    component: () => import("./views/categoryOffers.vue"),
                    meta: {
                        hideSaldo: true,
                    }
                },
                {
                    path: '/network/membershipLanding',
                    name: 'membershipLanding',
                    component: () => import("./views/membershipLanding.vue"),
                    meta: {
                        hideSaldo: true,
                        hasBar: true,
                    }
                },
                {
                    path: '/network/buyClubSubscription',
                    name: 'buyClubSubscription',
                    component: () => import("./views/buyClubSubscription.vue"),
                    meta: {
                        hideSaldo: true,
                    }
                },
                {
                    path: '/network/shop/singleOffer/:offerIdentifier',
                    name: 'singleOffer',
                    component: () => import("./views/categoryOffers.vue"),
                },
                {
                    path: '/network/shop/upsellOffers/:parentOfferIdentifier',
                    name: 'upsellOffers',
                    component: () => import("./views/categoryOffers.vue"),
                },
                {
                    path: '/network/shop/buy/:offerIdentifier',
                    name: 'buyOffer',
                    component: () => import("./views/buyOffer.vue"),
                    meta: {
                        hideSaldo: true,
                    }
                },
                {
                    path: '/network/shop/thankyou/:isDeferred/:isEntryOffer',
                    name: 'thankyou',
                    component: () => import("./views/thankyou.vue"),
                    meta: {
                        hideSaldo: true,
                    }
                },
            ]
        },
    ];
};